import EgressGateway from "../../EgressGateway/EgressGateway"
import React,{ useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Groups, Group, ViewField, TabList, FormFooter, Button, FormField } from "../../../components/Form"
import {renderField, required} from "../../../utils/formValidations";
import moment from "moment";
   



export default function ViewEgressProvider(props) {
    const [currentEgressProvider, setCurrentEgressProvider] = useState(false);
    const egress_providers = useSelector(state => state.egress_provider.egress_providers) || null
    const { currentTab } = props


    useEffect(() => {
        if (egress_providers) {
            const currentProvider = props.match.params.id || null
            setCurrentEgressProvider(egress_providers.find(provider => provider.egress_provider_id === currentProvider))
        }
    }, [egress_providers]);

    return (
        <React.Fragment>
            <div className={(currentTab === 'gateway' ? 'tw-block' : 'tw-hidden')}>
                <EgressGateway egressProviderId={props.match.params.id} {...props} />
            </div>
            <div className={(currentTab === 'details') ? 'tw-block' : 'tw-hidden'}>
                <Groups section="egress_provider_info">
                    <Group section="egress_provider_info" title="details" description="details-description">
                        <ViewField type="text"
                            name="egress_provider_id"
                            value={currentEgressProvider && currentEgressProvider.egress_provider_id || "-"}
                            component={renderField}
                        />
                        <ViewField type="datetime-local"
                            name="created"
                            value={currentEgressProvider && moment(currentEgressProvider.created).isValid() ? 
                                moment.utc(currentEgressProvider.created).local().format("lll") : "-"}
                            component={renderField}
                        />
                    </Group>
                    <Group section="egress_provider_info" title="egress-plugins" description="egress-plugins-description">
                        <ViewField type="text"
                            name="is_managed"
                            help="kb-26-15"
                            value={currentEgressProvider && currentEgressProvider.is_managed || "-"}
                            component={renderField}
                        />
                        <ViewField type="text"
                            name="egress_plugin_id"
                            help="kb-26-16"
                            value={currentEgressProvider && currentEgressProvider.egress_plugin_id || "-"}
                            component={renderField}
                        />
                        <ViewField type="text"
                            name="egress_plugin_account_count"
                            help="kb-26-17"
                            value={currentEgressProvider && currentEgressProvider.egress_plugin_account_count}
                            component={renderField}
                        />
                        <ViewField type="number"
                            name="egress_plugin_active_connections"
                            value={currentEgressProvider && currentEgressProvider.egress_plugin_active_connections}
                            component={renderField}
                            help="kb-26-18"
                        />
                        <ViewField type="text"
                            name="egress_plugin_remaining_connections"
                            value={currentEgressProvider && currentEgressProvider.egress_plugin_remaining_connections}
                            component={renderField}
                            help="kb-26-19"
                        />
                    </Group>


                </Groups>
            </div>



        </React.Fragment>
    )

}
        